import { connect } from 'react-redux';
import PlanSliders from './PlanSliders';
import { addOptionToNewOffer } from '../../../modules/NewOffer/actions';
import config from '../../../config';
import {
  getCreditableOptionsWithPlanWithZeroValues,
  getLocalCreditableOptionsWithPlanWithZeroValues,
  newOfferOptionsSelector,
} from '../../../modules/NewOffer/selectors';
import {
  getCreditableOptionsWithPlan,
  getLocalCreditableOptionsWithPlan,
} from '../../../modules/AvailableOption/selectors';

const mapStateToProps = state => ({
  selectedOptions: newOfferOptionsSelector(state),
  creditableOptions: config.displayRoamingPlanSliders
    ? (config.addZeroOptionForEachService
        ? getLocalCreditableOptionsWithPlanWithZeroValues(state)
        : getLocalCreditableOptionsWithPlan(state))
    : (config.addZeroOptionForEachService
        ? getCreditableOptionsWithPlanWithZeroValues(state)
        : getCreditableOptionsWithPlan(state)),
  priceKey: 'taxIncludedAmount',
});

const mapDispatchToProps = {
  addOptionToNewOffer,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanSliders);
